import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../../theme';

import {Dialog, DialogActions, DialogContent, DialogTitle, Button} from '@material-ui/core'
import {Box, Container, TextField} from '@material-ui/core'
import { isInteger, isNegativeNumber, isNumber } from '../../../../api/validators';


class EditKmlLayerDialog_ extends React.Component {

    constructor(props){
        super(props)

        console.log('EditKmlLayerDialog');
        console.log(this.props)

        let kmlLayer = this.props.kmlLayer ? {...this.props.kmlLayer} : this.getDefaults()
        
        console.log(kmlLayer)

        this.state = {
            kmlLayer: kmlLayer?kmlLayer:{},
            errors: {
                Name: false,
                Url: false,
                RefreshInterval: false
            },
            changed: false,
        }


        this.handleAction = this.handleAction.bind(this)
        this.handleInput = this.handleInput.bind(this)

    }

    getDefaults(){
        let kmlLayer = {
            //ID: getBase64ID(),
            ID: null,
            Name: '',
            Url: '',
            RefreshInterval: 0
        }

        return kmlLayer
    }


    handleClose(){

        this.props.onAction({type: 'KML_LAYER_DIALOG_CLOSE'})
        
    }
    
    handleSave(){
        if(this.validate()){
            let kmlLayer = {...this.props.kmlLayer, ...this.state.kmlLayer}
            this.props.onAction({type: 'KML_LAYER_DIALOG_SAVE', kmlLayer: kmlLayer})
        }else{
            //this.props.onAction({type:'ALERT_DIALOG', message: this.props.t('CheckFormForErrors')})
        }
    }

    validate(){
        
        let kmlLayer = {...this.props.kmlLayer, ...this.state.kmlLayer}

        let check = true

        let errors = this.state.errors;

        if(!kmlLayer.Name){
            errors.Name = this.props.t('NameMustBeSpecified')
            check = false
        }else{
            errors.Name = false
        }

        if(kmlLayer.RefreshInterval && !isInteger(kmlLayer.RefreshInterval)){
            errors.RefreshInterval = this.props.t('IsNotNumber')
            check = false
        }else if(kmlLayer.RefreshInterval && isNegativeNumber(kmlLayer.RefreshInterval)){
            errors.RefreshInterval = this.props.t('RefreshInterval') + ': ' +  this.props.t('IsNotNegativeNumber'); 
            check = false
        }else{
            errors.RefreshInterval = false
        }

        this.setState({errors: errors})

        return check
    }


    handleAction(action){
        switch(action.type){

            default:
                console.log('Undefined action case: '+action.type)
        }
        
    }


    handleTabChange(event, newValue){
        this.setState({tab: newValue})
    }

    handleInput(event){
        const changed = !this.state.changed ? {changed: true} : {}
        let val =  event.target.type==='checkbox' ? event.target.checked : event.target.value 

        if(event.target.name=='RefreshInterval'){
            val = Number(val)
            if (isNaN(val)) val = 0
        }

        //console.log(event.target.name + ' val='+val)
        const kmlLayer = {...this.state.kmlLayer, [event.target.name]: val}
        this.setState({kmlLayer: kmlLayer, ...changed})
    }
    
    render(){
        const {t} = this.props

        const title = t('KmlLayer')

        //const margin = {}//{margin: 0}

        const styles = {
            tab:{
                minWidth:80
            },
            tabPanel:{
                minHeight: 300
            }
        };

        const margin = {margin:'16px 0 8px 0'}

        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
    <DialogContent style={{minWidth:450}}>

        <form>
        <Container maxWidth="lg" style={{minWidth:300}}>
            <Box textAlign="center">
                <TextField name="Name"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.Name?this.state.errors.Name:t('Name')}
                    autoComplete="new-password"
                    error={this.state.errors.Name!==false}
                    value={this.state.kmlLayer.Name}
                    onChange={this.handleInput}
                />
            </Box>

            <Box textAlign="center">
                <TextField name="Url"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.Url?this.state.errors.Url:t('KmlUrl')}
                    autoComplete="new-password"
                    error={this.state.errors.Url!==false}
                    value={this.state.kmlLayer.Url}
                    onChange={this.handleInput}
                />
            </Box>

            {/*<p>{this.state.kmlLayer.CurrentUrl}</p>*/}

            <Box textAlign="center">
                <TextField name="RefreshInterval"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.RefreshInterval?this.state.errors.RefreshInterval:t('RefreshInterval')}
                    autoComplete="new-password"
                    error={this.state.errors.RefreshInterval!==false}
                    value={this.state.kmlLayer.RefreshInterval}
                    onChange={this.handleInput}
                />   
            </Box>
        </Container>
        </form>


    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSave.bind(this)} variant="contained" color="primary">
            {t('Apply')}
        </Button>
        <Button onClick={this.handleClose.bind(this)} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }

}


export const EditKmlLayerDialog = withTranslation()(EditKmlLayerDialog_);


